import { Component, ChangeDetectionStrategy, OnInit, HostListener, inject, forwardRef } from '@angular/core';
import { WindowService } from '@shared/window/window.service';
import { FooterMenuComponent } from '../components/footer-menu/footer-menu.component';
import { AdditionalInfoComponent } from '../components/additional-info/additional-info.component';
import { ContactComponent } from '../components/contact/contact.component';
import { SocialComponent } from '../components/social/social.component';
import { CopyComponent } from '../components/copy/copy.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FooterMenuComponent, AdditionalInfoComponent, ContactComponent, SocialComponent, CopyComponent, forwardRef(() => FooterComponent)],
})
export class FooterComponent implements OnInit {
    private windowService = inject(WindowService);

    isDesktop!: boolean;

    ngOnInit(): void {
        this.isDesktop = this.windowService.checkWindowWidth(992);
    }

    @HostListener('window:resize') onWindowResize(): void {
        this.isDesktop = this.windowService.checkWindowWidth(992);
    }
}
